<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submitForm")
        v-layout(raw wrap)
            v-flex(xs12)

                // Current password field
                v-text-field(
                    name="currentPassword"
                    :label="$t('fields.current_password')"
                    ref="currentPassword"
                    v-model="model.currentPassword"
                    v-validate="{ required: true, min: 6, max: 24 }"
                    :data-vv-as="$t('profile.fields.password')"
                    :error-messages="errors.collect('currentPassword')"
                    outline
                    autocomplete="off"

                    :append-icon="visibilityPassword ? 'visibility' : 'visibility_off'"
                    @click:append="() => (visibilityPassword = !visibilityPassword)"
                    :type="visibilityPassword ? 'text' : 'password'"
                )

            v-flex(xs12)

                // Password field
                v-text-field(
                    name="password"
                    :label="$t('profile.fields.newPassword')"
                    ref="password"
                    v-model="model.password"
                    v-validate="{ required: true, min: 6, max: 24, is: model.password, verify_password: true }"
                    :data-vv-as="$t('profile.fields.newPassword')"
                    :error-messages="errors.collect('password')"
                    outline
                    autocomplete="off"

                    :append-icon="visibilityPassword ? 'visibility' : 'visibility_off'"
                    @click:append="() => (visibilityPassword = !visibilityPassword)"
                    :type="visibilityPassword ? 'text' : 'password'"
                )

            v-flex(xs12)

                // Password confirmation field
                v-text-field(
                    name="confirmPassword"
                    :label="$t('profile.fields.confirmNewPassword')"
                    ref="confirmPassword"
                    v-model="model.confirmPassword"
                    v-validate="{ required: true, min: 6, max: 24, is: model.password, verify_password: true }"
                    :data-vv-as="$t('profile.fields.confirmNewPassword')"
                    :error-messages="errors.collect('confirmPassword')"
                    outline
                    autocomplete="off"

                    :append-icon="visibilityPassword ? 'visibility' : 'visibility_off'"
                    @click:append="() => (visibilityPassword = !visibilityPassword)"
                    :type="visibilityPassword ? 'text' : 'password'"
                )
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import profile from '~api/profile';
    import Handler from '~services/Handler';
    import i18n from '../../../../i18n';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        data() {
            return {
                model: {
                    currentPassword: null,
                    password: null,
                    confirmPassword: null
                },
                visibilityPassword: false
            };
        },
        computed: {
            ...mapGetters('auth', ['isInstructor'])
        },
        mounted() {
            const dict = {
                custom: {
                    confirmPassword: {
                        is: 'Oops! It looks like your password doesn’t match.',
                        min: 'Your password must be at least 8 characters.',
                        max:
                            'Your password may not be greater than 24 characters'
                    }
                }
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['isLoading']),

            /**
             * Clear form fields
             */
            clearForm: function() {
                // Clear form fields
                this.model = {};
                // Clear validator
                this.$validator.reset();
            },

            /**
             * Update password on submit
             * @returns {Promise<void>}
             */
            async submitForm() {
                const successMessage = i18n.t('profile.successMessage');
                const errorMessage = i18n.t('profile.errorMessage');

                if (
                    !this.model.confirmPassword &&
                    !this.model.currentPassword &&
                    !this.model.password
                ) {
                    this.$router.go(-1);
                    return;
                }

                // Validate all fields
                const validation = await this.$validator.validateAll();

                // Check validation pass
                if (!validation) return;

                this.isLoading = true;

                profile.updatePassword(this.model).then(resp => {
                    Handler.handleResponse(resp, successMessage, errorMessage);

                    if (resp.ok) {
                        this.clearForm();
                    }

                    this.isLoading = false;
                });
            }
        }
    };
</script>
